import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_labresult-hub-1/artifacts/td8pjg41_FACTUAL%20LOGO.png";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      {/* Header */}
      <header className="bg-slate-900 text-white py-4">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Logo" className="w-10 h-10 rounded-full" />
            <span className="font-bold text-lg">Factual Medical Diagnostic Centre</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-white hover:text-sky-300">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-700 to-slate-900 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-slate-300">Last updated: February 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">1. Introduction</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              Factual Medical Diagnostic Centre ("we", "our", or "us") is committed to protecting your privacy 
              and ensuring the security of your personal and medical information. This Privacy Policy explains 
              how we collect, use, disclose, and safeguard your information when you use our services.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">2. Information We Collect</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">We collect information that you provide directly to us, including:</p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 mb-6 space-y-2">
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Date of birth and gender</li>
              <li>Medical history and health information</li>
              <li>Lab test results and diagnostic data</li>
              <li>Payment information</li>
              <li>Communication records with our staff</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">3. How We Use Your Information</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 mb-6 space-y-2">
              <li>Provide diagnostic and medical laboratory services</li>
              <li>Process and deliver your lab results</li>
              <li>Communicate with you about appointments and results</li>
              <li>Process payments for services rendered</li>
              <li>Maintain and improve our services</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">4. Data Security</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              We implement appropriate technical and organizational measures to protect your personal and 
              medical information against unauthorized access, alteration, disclosure, or destruction. 
              This includes encryption, secure servers, and restricted access protocols.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">5. Information Sharing</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">We may share your information with:</p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 mb-6 space-y-2">
              <li>Healthcare providers involved in your care (with your consent)</li>
              <li>Payment processors for transaction processing</li>
              <li>Government authorities when required by law</li>
              <li>Third-party service providers who assist our operations</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">6. Your Rights</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 mb-6 space-y-2">
              <li>Access your personal and medical information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
              <li>Withdraw consent for data processing</li>
              <li>Receive a copy of your data in a portable format</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">7. Data Retention</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              We retain your personal and medical information for as long as necessary to fulfill the 
              purposes outlined in this policy, or as required by law. Medical records are retained in 
              accordance with Nigerian healthcare regulations.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">8. Contact Us</h2>
            <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-lg">
              <p className="text-slate-700 dark:text-slate-300 mb-2">
                If you have questions about this Privacy Policy or our data practices, please contact us at:
              </p>
              <p className="text-slate-700 dark:text-slate-300"><strong>Email:</strong> FACTUALMEDICALDIAGNOSTICCENTRE@GMAIL.COM</p>
              <p className="text-slate-700 dark:text-slate-300"><strong>Phone:</strong> 09049816536, 08025072241, 08141571388</p>
              <p className="text-slate-700 dark:text-slate-300"><strong>Address:</strong> No 502, Arogun Bus Stop, Mowe/Ofada Road, Adjacent Medicplus Hospital, Ogun State, Nigeria</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-slate-400">&copy; {new Date().getFullYear()} Factual Medical Diagnostic Centre. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
